export const environment = {
  production: true,
  splixerUrl: 'https://player-api.splixer.com/player_api/v3/',
  defaultStationCode: 'f3f715e8-76f8-4136-8ca4-c3d4ec2c4d08',
  defaultGaTrackingId: 'G-3VH0YZCXNZ',
  debugMode: false,
  showDebugInfo: true,
};
